/**
 * @module utils/toChartTypeEnum
 * @description DVA chartType 字符串 → ChartType 合法取值
 */

import { ChartType, type TChartType } from '@dbl/core/chart';

const CHART_TYPE_VALUES = new Set<string>(Object.values(ChartType));

export function toChartTypeEnum(chartTypeStr: string): TChartType {
  if (CHART_TYPE_VALUES.has(chartTypeStr)) {
    return chartTypeStr as TChartType;
  }
  return ChartType.Table;
}
